import type { CSSProperties } from 'react';

const TABS = ['기능 확장 및 워크플로우 재사용', '운영 현황 및 사용자 관리', 'AI 서비스 연결 및 지식 검색 관리', '고객사 및 토큰 비용 관리', 'AI 거버넌스 및 운영 이력 관리'];

export default function AdminSection() {
  return (
    <section className="qs" id="s6">
      <div className="wrap">
        <div className="qhd pd-rv">
          <div>
            <span className="ey">
              <b>06</b>
              관리 기능
            </span>
            <small>AI를 만든 뒤 운영·관리까지 한곳에서</small>
            <h2>
              운영과
              {' '}
              <em>사용자·시스템 관리</em>
            </h2>
          </div>
        </div>
        <div className="qadm pd-rv">
          <div className="qtabs">
            {TABS.map((t, i) => (
              <button key={t} className={i === 0 ? 'on' : undefined} data-p={i + 1}>
                <b>{`0${i + 1}`}</b>
                {t}
                <svg className="i">
                  <use href="#arr" />
                </svg>
              </button>
            ))}
          </div>
          <label className="qsel">
            <select
              aria-label="관리 기능 선택"
              onChange={(e) => e.currentTarget.closest('.qadm')?.querySelector<HTMLButtonElement>(`.qtabs button[data-p="${e.currentTarget.value}"]`)?.click()}
            >
              {TABS.map((t, i) => (
                <option key={t} value={i + 1}>{`0${i + 1}  ${t}`}</option>
              ))}
            </select>
          </label>
          <div>
            <div className="qpane qc2 on" data-p="1">
              <div className="qcd pd-rv">
                <div className="il p">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "20px" }}>
                    <div className="r">
                      <span className="mini-ic w">
                        <img src="/site/logos/slack.svg" alt="" />
                      </span>
                      Slack
                      <span className="btnm o">제거</span>
                    </div>
                    <div className="r">
                      <span className="mini-ic w">
                        <img src="/site/logos/notion.svg" alt="" />
                      </span>
                      Notion
                      <span className="btnm">설치</span>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "#0F172A" }}>
                        <svg className="i">
                          <use href="#server" />
                        </svg>
                      </span>
                      MCP 서버
                      <span className="btnm">설치</span>
                    </div>
                  </div>
                </div>
                <h4>마켓플레이스</h4>
                <p>업무에 필요한 노드와 도구를 찾아 추가합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    기능별 도구 검색 및 설치·제거
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    설치한 노드를 워크플로우에서 활용
                  </li>
                </ul>
              </div>
              <div className="qcd pd-rv">
                <div className="il s">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "24px", padding: "14px" }}>
                    <div style={{ display: "flex", alignItems: "center", fontSize: "13px", fontWeight: "800" }}>
                      사내 문서 RAG 챗봇
                      <span className="btnm">불러오기</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "14px" }}>
                      <span className="mini-ic" style={{ background: "var(--grn)" }}>
                        <svg className="i">
                          <use href="#msg" />
                        </svg>
                      </span>
                      <span style={{ flex: "1", height: "2px", background: "#DCD9FA" }} />
                      <span className="mini-ic" style={{ background: "var(--blu)" }}>
                        <svg className="i">
                          <use href="#doc" />
                        </svg>
                      </span>
                      <span style={{ flex: "1", height: "2px", background: "#DCD9FA" }} />
                      <span className="mini-ic" style={{ background: "var(--pnk)" }}>
                        <svg className="i">
                          <use href="#spark" />
                        </svg>
                      </span>
                      <span style={{ flex: "1", height: "2px", background: "#DCD9FA" }} />
                      <span className="mini-ic" style={{ background: "var(--ac)" }}>
                        <svg className="i">
                          <use href="#send" />
                        </svg>
                      </span>
                    </div>
                    <div style={{ fontSize: "11px", color: "var(--t4)", marginTop: "12px" }}>필요 : 지식베이스 연결</div>
                  </div>
                </div>
                <h4>워크플로우 템플릿</h4>
                <p>배포된 워크플로우를 복사해 내 업무에 맞게 사용합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    챗봇·스케줄 템플릿 검색·실행
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    노드·연결선·지식베이스 복사 및 편집
                  </li>
                </ul>
              </div>
            </div>
            <div className="qpane qc2" data-p="2">
              <div className="qcd pd-rv">
                <div className="il p">
                  <div className="mk" style={{ left: "24px", top: "22px", width: "44%" }}>
                    <div className="kpi">
                      <small>
                        <span className="dt" style={{ background: "var(--ac)" }} />
                        워크플로우
                      </small>
                      <b>
                        12
                        <em>개</em>
                      </b>
                      <div className="pr">
                        <i style={{ width: "60%", background: "var(--ac)" }} />
                      </div>
                    </div>
                  </div>
                  <div className="mk" style={{ right: "24px", top: "52px", width: "44%" }}>
                    <div className="kpi">
                      <small>
                        <span className="dt" style={{ background: "var(--teal)" }} />
                        지식베이스
                      </small>
                      <b>
                        8
                        <em>개</em>
                      </b>
                      <div className="pr">
                        <i style={{ width: "40%", background: "var(--teal)" }} />
                      </div>
                    </div>
                  </div>
                </div>
                <h4>관리자 대시보드</h4>
                <p>워크플로우·챗봇·지식베이스의 운영 현황을 살펴봅니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    처리 상태와 사용자·문서 수 등 주요 통계 확인
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    최근 생성·배포·업로드 내역 확인
                  </li>
                </ul>
              </div>
              <div className="qcd pd-rv">
                <div className="il t">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "20px" }}>
                    <div className="r">
                      <span className="av" style={{ background: "var(--ac)" }}>김</span>
                      김이테
                      <span className="bdg p">관리자</span>
                    </div>
                    <div className="r">
                      <span className="av" style={{ background: "var(--teal)" }}>이</span>
                      이테크
                      <span className="bdg g">일반 사용자</span>
                    </div>
                    <div className="r">
                      <span className="av" style={{ background: "var(--org)" }}>박</span>
                      박시스
                      <span className="bdg g">일반 사용자</span>
                    </div>
                  </div>
                </div>
                <h4>사용자 관리</h4>
                <p>사용자 정보와 소속·역할을 관리합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    사용자 등록·검색·정보 수정·삭제
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    제품·조직·고객사별 관리자 및 일반 사용자 구분
                  </li>
                </ul>
              </div>
            </div>
            <div className="qpane qc2" data-p="3">
              <div className="qcd pd-rv">
                <div className="il p">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "16px" }}>
                    <div className="r">
                      <span className="mini-ic w">
                        <img src="/site/logos/aws.svg" alt="" />
                      </span>
                      Amazon Bedrock
                      <span className="tg tgl on" style={{ marginLeft: "auto" }} />
                    </div>
                    <div className="r">
                      <span className="mini-ic w">
                        <img src="/site/logos/openai.svg" alt="" />
                      </span>
                      OpenAI
                      <span className="tg tgl on" style={{ marginLeft: "auto" }} />
                    </div>
                    <div className="r">
                      <span className="mini-ic w">
                        <img src="/site/logos/anthropic.svg" alt="" />
                      </span>
                      Anthropic
                      <span className="tg tgl" style={{ marginLeft: "auto" }} />
                    </div>
                  </div>
                </div>
                <h4>AI 서비스 연결과 기본 설정</h4>
                <p>사용할 AI 서비스를 연결하고 기본 응답·검색 기준을 설정합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    Amazon Bedrock·OpenAI·Anthropic·Google AI 연결
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    AI 모델·답변 언어·응답 방식·검색 기준 설정
                  </li>
                </ul>
              </div>
              <div className="qcd pd-rv">
                <div className="il s">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "20px" }}>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--blu)" }}>
                        <svg className="i">
                          <use href="#search" />
                        </svg>
                      </span>
                      <span style={{ color: "var(--t4)" }}>휴가 신청 절차</span>
                      <span className="btnm">테스트</span>
                    </div>
                    <div className="r">
                      사내 업무 매뉴얼
                      <em>0.86</em>
                    </div>
                    <div className="r">
                      직무전결규정
                      <em>0.74</em>
                    </div>
                  </div>
                </div>
                <h4>지식 검색 설정·테스트</h4>
                <p>검색 방식을 설정하고 실제 검색 결과를 확인합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    의미 기반·키워드 병행 검색과 결과 정렬 설정
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    검색된 내용·문서명·유사도 확인
                  </li>
                </ul>
              </div>
            </div>
            <div className="qpane qc2" data-p="4">
              <div className="qcd pd-rv">
                <div className="il t">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "20px" }}>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--ac)" }}>
                        <svg className="i">
                          <use href="#building" />
                        </svg>
                      </span>
                      ETECH
                      <span className="bdg g">활성</span>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--teal)" }}>
                        <svg className="i">
                          <use href="#building" />
                        </svg>
                      </span>
                      고객사 A
                      <span className="bdg g">활성</span>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "#8B95A1" }}>
                        <svg className="i">
                          <use href="#building" />
                        </svg>
                      </span>
                      고객사 B
                      <span className="bdg o">대기</span>
                    </div>
                  </div>
                </div>
                <h4>고객사 관리</h4>
                <p>고객사 정보와 소속 조직·상태를 관리합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    고객사 등록·검색·정보 수정
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    고객사 코드·소속 조직·상태 확인
                  </li>
                </ul>
              </div>
              <div className="qcd pd-rv">
                <div className="il k">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "18px" }}>
                    <div className="hd">
                      일별 토큰 사용량
                      <span className="btnm o">CSV</span>
                    </div>
                    <div className="mbars">
                      <i style={{ height: "50%", "--o": "40%" } as CSSProperties} />
                      <i style={{ height: "72%", "--o": "35%" } as CSSProperties} />
                      <i style={{ height: "60%", "--o": "45%" } as CSSProperties} />
                      <i style={{ height: "88%", "--o": "30%" } as CSSProperties} />
                      <i style={{ height: "66%", "--o": "38%" } as CSSProperties} />
                      <i style={{ height: "94%", "--o": "32%" } as CSSProperties} />
                      <i style={{ height: "78%", "--o": "40%" } as CSSProperties} />
                    </div>
                  </div>
                </div>
                <h4>토큰 비용 관리</h4>
                <p>AI 사용량과 비용을 사용자·모델별로 확인합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    일별 입력·출력 토큰 사용량 분석
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    조건별 조회 및 CSV 내보내기
                  </li>
                </ul>
              </div>
            </div>
            <div className="qpane qc2" data-p="5">
              <div className="qcd pd-rv">
                <div className="il p">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "20px" }}>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--ac)" }}>
                        <svg className="i">
                          <use href="#shield" />
                        </svg>
                      </span>
                      설정 변경
                      <em>10.13 13:47</em>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--teal)" }}>
                        <svg className="i">
                          <use href="#users" />
                        </svg>
                      </span>
                      사용자 등록
                      <em>10.13 11:02</em>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--org)" }}>
                        <svg className="i">
                          <use href="#layers" />
                        </svg>
                      </span>
                      워크플로우 배포
                      <em>10.12 17:20</em>
                    </div>
                  </div>
                </div>
                <h4>감사 로그</h4>
                <p>사용자와 관리자의 주요 작업을 기록으로 확인합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    작업 사용자·대상·결과·IP 확인
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    설정 변경 전후 이력 추적 및 검색
                  </li>
                </ul>
              </div>
              <div className="qcd pd-rv">
                <div className="il k">
                  <div className="mk" style={{ left: "24px", right: "24px", top: "20px" }}>
                    <div className="r">
                      <span className="dt" style={{ background: "#F87171" }} />
                      DB 조회 자동 보고 메일
                      <span className="bdg" style={{ background: "#FDECEC", color: "#DC2626" }}>실패</span>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "var(--org)" }}>
                        <svg className="i">
                          <use href="#db" />
                        </svg>
                      </span>
                      DB 조회 노드
                      <em>2.4s</em>
                    </div>
                    <div className="r">
                      <span className="mini-ic" style={{ background: "#E5484D" }}>
                        <svg className="i">
                          <use href="#alert" />
                        </svg>
                      </span>
                      <span style={{ color: "#DC2626" }}>연결 시간 초과</span>
                      <span className="btnm o">이동</span>
                    </div>
                  </div>
                </div>
                <h4>실패 로그</h4>
                <p>워크플로우 실행 오류와 원인 파악에 필요한 정보를 확인합니다.</p>
                <ul>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    실패 시각·소요 시간·오류 내용 확인
                  </li>
                  <li>
                    <svg className="i">
                      <use href="#ccheck" />
                    </svg>
                    노드별 실행 결과 확인 및 해당 워크플로우 이동
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="pnote pd-rv">
          <span>도구와 템플릿을 활용하고, 사용자·고객사·AI 설정과 운영 이력을 관리합니다.</span>
        </div>
      </div>
    </section>
  );
}
